/**
 * MapContainer
 * --
 */
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { KakaoMap } from 'components';

const MapContainer = () => {
  /* ===== ROUTE ===== */
  const [searchParams] = useSearchParams();
  const props = searchParams.get('props');
  console.log('props', props);

  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const decodeProps = React.useMemo(() => {
    return JSON.parse(props);
  }, [props]);
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <KakaoMap {...decodeProps} />
    </>
  );
};

export default MapContainer;
